import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import * as Events from '../lib/events';

const MODAL_BODY_CLASS = 'is-modal-open';

export default (el, props) => {
    const dom = $(el);
    const body = $('body');
    const slides = dom.find('[data-menu-slide]');
    let active = false;
    let trigger = false;

    const setInitialSlideState = () => {
        slides.each(node => {
            TweenLite.set(node, { opacity: 0, x: 50 });
        });
    };

    const keyHandler = e => {
        const key = e.keyCode || e.which;
        if (active && key === 27) {
            Dispatch.emit(Events.MENU_CLOSE);
        }
    };

    const onOpen = () => {
        if (!active) {
            active = true;
            document.addEventListener('keyup', keyHandler);
            TweenLite.set(el, { display: 'block', opacity: 0 });
            body.addClass(MODAL_BODY_CLASS);
            TweenLite.to(el, 0.4, { opacity: 1, ease: Quart.easeInOut });
            trigger = document.activeElement;
            Viewport.lockTabbing([el, $('[data-search]').get(0)], dom.find('a').get(0));
            let delay = 0.25;
            slides.each(node => {
                TweenLite.to(node, 1.25, { delay, x: 0, ease: Expo.easeOut });
                TweenLite.to(node, 0.25, { delay, opacity: 1, ease: Sine.easeOut });
                delay += 0.03;
            });
        }
    };

    const onClose = () => {
        if (active) {
            active = false;
            document.removeEventListener('keyup', keyHandler);
            body.removeClass(MODAL_BODY_CLASS);
            TweenLite.to(el, 0.2, {
                opacity: 0,
                ease: Cubic.easeOut,
                clearProps: 'display,opacity',
                onComplete: setInitialSlideState
            });
            Viewport.releaseTabbing(trigger);
        }
    };

    const init = () => {
        setInitialSlideState();
        Dispatch.on(Events.MENU_OPEN, onOpen);
        Dispatch.on(Events.MENU_CLOSE, onClose);
    };

    const destroy = () => {
        Dispatch.off(Events.MENU_OPEN, onOpen);
        Dispatch.off(Events.MENU_CLOSE, onClose);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Menu.js